import { lazy } from 'react';
import type { ApiEntity } from '@backstage/catalog-model';
import { createApiFactory } from '@backstage/core-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import yaml from 'yaml';

const LazyRedocApiDefinition = lazy(() =>
  import('./components/RedocApiDefinition').then(m => ({
    default: m.RedocApiDefinition,
  })),
);

export const createApiDocsConfigFactory = () =>
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => {
      const definitionWidgets = defaultDefinitionWidgets();
      return {
        getApiDefinitionWidget: (apiEntity: ApiEntity) => {
          if (apiEntity.spec.type === 'openapi') {
            return {
              rawLanguage: 'json',
              title: 'OpenAPI',
              type: 'openapi',
              component: (definition: string) => (
                <LazyRedocApiDefinition definition={yaml.parse(definition)} />
              ),
            };
          }
          return definitionWidgets.find(d => d.type === apiEntity.spec.type);
        },
      };
    },
  });
